import React, { useState } from "react";
import "./subsolos.css";
import GroupLightComponent from "../configs/LightGroupConfig";
import image1 from "../../../assets/img/subsolos/subsolo-01.png";
import image2 from "../../../assets/img/subsolos/subsolo-02.png";

const Subsolo = () => {
    const [subsoloAtual, setSubsoloAtual] = useState("sub01");

    return (
        <div className="CampoSubsolo">
            <div className="menuSubSolo">
                <button
                    className={`botaoSubSolo ${subsoloAtual === "sub01" ? "selecionado" : ""}`}
                    onClick={() => setSubsoloAtual("sub01")}
                >
                    Sub 01
                </button>
                <button
                    className={`botaoSubSolo ${subsoloAtual === "sub02" ? "selecionado" : ""}`}
                    onClick={() => setSubsoloAtual("sub02")}
                >
                    Sub 02
                </button>
            </div>
            
            <div className="subSoloSelecionado">
                <img 
                    className="imagemSubsolo" 
                    src={subsoloAtual === "sub01" ? image1 : image2} 
                    alt="subsolo" 
                />
                
                {subsoloAtual === "sub01" && (
                    <GroupLightComponent 
                        groupIds={["grupo21"]} 
                        pageTitle="Vigia SS1"
                        pageId="subsolo"
                        showLegend={false} // Desativa a legenda automática
                    />
                )}
                
                {subsoloAtual === "sub02" && (
                    <GroupLightComponent 
                        groupIds={["grupo20"]} 
                        pageTitle="Vigia SS2"
                        pageId="subsolo"
                        showLegend={false} // Desativa a legenda automática
                    />
                )}
            </div>
        </div>
    );
};

export default Subsolo;